


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLeadForm } from "../hooks/useLeadForm";
import GeneralInfoSection from "../components/forms/GeneralInfoSection";
import ElectricitySection from "../components/forms/ElectricitySection";
import GasSection from "../components/forms/GasSection";
import QualityReviewSection from "../components/forms/QualityReviewSection";
import Swal from "sweetalert2";

export default function CreateLeadPage() {
  const navigate = useNavigate();

  // const { form, errors, isSaving, setField, reset, saveLead, serverError, setServerError } = useLeadForm();
  const { form, errors, isSaving, setField, removeVoxFile, removeAttachment, reset, saveLead, serverError, setServerError } = useLeadForm();
  

  const [saveSuccess, setSaveSuccess] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const showElec =
    form.validationType === "Electricity + Gas" ||
    form.validationType === "Electricity Only";

  const showGas =
    form.validationType === "Electricity + Gas" ||
    form.validationType === "Gas Only";

  // ── SAVE ─────────────────────────────────────────────────
  const handleSave = async () => {
    setServerError("");
    const ok = await saveLead();

    if (ok) {
      Swal.fire({
        icon: "success",
        title: "Lead Saved!",
        text: "Lead has been created successfully.",
        confirmButtonColor: "#2563eb",
        timer: 1500,
        showConfirmButton: false,
      });

      setSaveSuccess(true);

      setTimeout(() => {
        setSaveSuccess(false);

        const disposition = form.leadDisposition?.trim();

        if (disposition === "Quality") navigate("/quality-leads");
        else if (disposition === "Quality Low AQ") navigate("/qualitylowaq-leads");
        else if (disposition === "Quality OO") navigate("/quality00-leads");
        else if (disposition === "Callback") navigate("/callback-leads");
        else if (disposition === "Hold") navigate("/hold");
        else if (disposition === "Validate") navigate("/validate");
        else if (disposition === "Validate OO") navigate("/validate-00");
        else if (disposition === "Validate Low AQ") navigate("/validate-low-aq");
         else if (disposition === "Reject") navigate("/rejects");
         else if (disposition === "Sold") navigate("/sold");
        else navigate("/leadslist");
      }, 1600);

    } else {
      Swal.fire({
        icon: "error",
        title: "Save Failed",
        text: "Please fix the errors highlighted in the form.",
        confirmButtonColor: "#dc2626",
      });
    }
  };

  // ── RESET ─────────────────────────────────────────────────
  const handleReset = () => {
    Swal.fire({
      title: "Reset Form?",
      text: "All entered data will be cleared.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset",
    }).then((result) => {
      if (result.isConfirmed) {
        reset();
        Swal.fire({
          icon: "success",
          title: "Reset Complete",
          text: "Form has been cleared.",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  return (
    <div  className="text-slate-800">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900">
            Create New Lead
          </h1>
          <nav className="text-xs text-slate-400 mt-0.5">
            <span>Leads</span>
            <span className="mx-1">›</span>
            <span className="text-slate-600">Create New Lead</span>
          </nav>
        </div>
        <span className="bg-blue-50 border border-blue-200 text-blue-700 text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5">
          {form.validationType || "Not Selected"}
        </span>
      </div>

      {/* SUCCESS BANNER */}
      {saveSuccess && (
        <div className="mb-4 bg-green-50 border border-green-200 text-green-700 text-sm font-medium px-4 py-3 rounded-xl flex items-center gap-2">
          ✔ Lead saved successfully!
        </div>
      )}

      {/* VALIDATION ERROR BANNER */}
      {Object.keys(errors).length > 0 && (
        <div className="mb-4 bg-red-50 border border-red-200 text-red-700 text-sm font-medium px-4 py-3 rounded-xl flex items-center gap-2">
          ⚠ Please fix the highlighted errors before saving.
        </div>
      )}
      {/* SERVER ERROR BANNER */}
      {serverError && (
        <div className="mb-4 bg-red-50 border border-red-200 text-red-700 text-sm font-medium px-4 py-3 rounded-xl flex items-center gap-2">
          ⚠ {serverError}
        </div>
      )}
      <div className="space-y-5">

        {/* GENERAL INFO */}
        <GeneralInfoSection
          form={form}
          errors={errors}
          setField={setField}
        />

        {/* ELECTRICITY + GAS */}
        {(showElec || showGas) && (
          <div className={`grid gap-5 ${showElec && showGas ? "grid-cols-2" : "grid-cols-1"}`}>
            {showElec && (
              <ElectricitySection
                form={form}
                errors={errors}
                setField={setField}
              />
            )}
            {showGas && (
              <GasSection
                form={form}
                errors={errors}
                setField={setField}
              />
            )}
          </div>
        )}

        {/* QUALITY REVIEW */}
        {(user?.role === "admin" || user?.role === "agent") && (
          <QualityReviewSection
            form={form}
            errors={errors}
            setField={setField}
            removeVoxFile={removeVoxFile}
            removeAttachment={removeAttachment}
          />
        )}

        {/* BUTTONS */}
        <div className="flex justify-end gap-3 pb-6">
          <button onClick={handleReset} className="btn-secondary">
            Reset
          </button>
          <button
            onClick={handleSave}
            disabled={isSaving}
            className="btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isSaving ? "Saving..." : "Save Lead"}
          </button>
        </div>

      </div>
    </div>
  );
}
